import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/26_card_back_calibri/26_card_back_calibri"
 * Contains 1 texture(s)
 */
export class CardsBacks26CardBackCalibriAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/26_card_back_calibri/26_card_back_calibri';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '26_calibri.png'
    ] as const;
}
